/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
import {
  EditOutlined, PlusOutlined, QuestionCircleOutlined
} from '@ant-design/icons';
import {
  Button, Row, Table, Tooltip, Typography
} from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';

import PackageCompareDetail from './components/PackageCompareDetail';

import HeaderPage from 'common/components/HeaderPage';
import Image from 'common/components/Image';
import { getPackageCompareService } from 'common/services/packages';
import { Item } from 'common/services/packages/types';

const { Title } = Typography;

const PackageCompare = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const { data } = useQuery(['getPackageCompareService', visible], () => getPackageCompareService());

  return (
    <>
      <HeaderPage fixed title={t('packageCompare.title')} />
      <div className="p-packagCompare t-mainlayout_wrapper">
        {!visible && (
          <Row justify="space-between" style={{ marginBottom: 24 }}>
            <Title level={3}>{t('packageCompare.subTitle')}</Title>
            <Button
              icon={data && data.length > 0 ? <EditOutlined /> : <PlusOutlined />}
              type="primary"
              onClick={() => setVisible(true)}
            >
              {data && data.length > 0 ? t('packageCompare.viewDetail') : t('system.create')}
            </Button>
          </Row>
        )}
        {
          data && data.length > 0 && !visible ? (
            data.map((section, sectionIndex) => {
              const numberCol = section.items[0]?.details.length || 0;
              return (
                <div key={`${section.name}-${sectionIndex}`} style={{ marginBottom: 24 }}>
                  <div className="p-packageCompare_header">
                    <div className="p-packageCompare_headerTable">
                      {section.icon && (
                        <div className="p-packageCompare_iconPreview">
                          <Image
                            ratio="1x1"
                            src={section.icon}
                            alt={t('packageCompare.imageAlt', { name: section.name, defaultValue: `Icon for ${section.name}` })}
                            aria-label={t('packageCompare.imageAlt', { name: section.name, defaultValue: `Icon for ${section.name}` })}
                          />
                        </div>
                      )}
                      <Title level={5} style={{ marginLeft: section.icon ? '10px' : '0', marginBottom: 16 }}>
                        {section.name}
                      </Title>
                    </div>

                  </div>
                  <Table
                    dataSource={section.items}
                    columns={[
                      {
                        dataIndex: 'name',
                        key: 'name',
                        render: (text, record) => (record.description ? (
                          <Tooltip title={record.description}>
                            <span style={{ cursor: 'pointer' }}>
                              {text}
                              {' '}
                              <QuestionCircleOutlined />
                            </span>
                          </Tooltip>
                        ) : (
                          text
                        )),
                      },
                      ...Array.from({ length: numberCol }, (_, i) => ({
                        title: ' ',
                        key: `detail_${i}`,
                        render: (__: any, record: Item) => (section.type === 'boolean'
                          ? record.details[i] === true
                            ? '✅'
                            : '❌'
                          : String(record.details[i] || '')),
                      })),
                    ]}
                    pagination={false}
                    rowKey={(record) => record.name}
                    bordered
                    aria-label={t('packageCompare.table', { name: section.name })}
                  />
                </div>
              );
            })
          ) : !visible && (
            <Typography.Text>{t('packageCompare.noData')}</Typography.Text>
          )
        }
        {
          visible && (
            <PackageCompareDetail tableList={data || []} numberCols={data?.[0].items[0].details.length || 4} onBack={() => setVisible(false)} />
          )
        }
      </div>
    </>
  );
};

export default PackageCompare;
